"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
var _themeTools = require("@chakra-ui/theme-tools");
const filledStyle = props => {
  const {
    colorScheme,
    hasStripe,
    isIndeterminate,
    theme
  } = props;
  const bgColor = colorScheme === 'gray' ? `${colorScheme}.dark` : `${colorScheme}.default`;
  const gradient = `linear-gradient(
      to right,
      transparent 0%,
      ${(0, _themeTools.getColor)(theme, bgColor)} 50%,
      transparent 100%
    )`;
  const addStripe = !isIndeterminate && hasStripe;
  return {
    ...(addStripe && (0, _themeTools.generateStripe)()),
    ...(isIndeterminate ? {
      bgImage: gradient
    } : {
      bgColor
    })
  };
};
const variantOutlined = props => {
  const {
    theme: {
      colors
    }
  } = props;
  return {
    track: {
      bg: 'transparent',
      borderWidth: '1px',
      borderColor: colors.gray['200']
    }
  };
};
const variantSolid = props => {
  const {
    theme: {
      colors
    }
  } = props;
  return {
    track: {
      bg: colors.gray['100']
    }
  };
};
const variants = {
  outlined: variantOutlined,
  solid: variantSolid
};
const sizes = {
  xl: {
    track: {
      height: 10
    }
  },
  lg: {
    track: {
      height: 6
    }
  },
  md: {
    track: {
      height: 4
    }
  },
  sm: {
    track: {
      height: 2
    }
  },
  xs: {
    track: {
      height: 1
    }
  }
};
const defaultProps = {
  size: 'lg',
  colorScheme: 'primary',
  variant: 'solid'
};
const overrides = {
  defaultProps,
  variants,
  sizes,
  baseStyle: props => {
    const {
      sx: {
        isRounded
      }
    } = props;
    return (0, _merge.default)(_theme.default.components.Progress.baseStyle(props), {
      filledTrack: {
        borderRightRadius: isRounded ? 'none' : 'base',
        ...filledStyle(props)
      },
      track: {
        borderRightRadius: isRounded ? 'full' : 'base',
        borderLeftRadius: isRounded ? 'full' : 'base'
      }
    });
  }
};
var _default = exports.default = {
  ..._theme.default.components.Progress,
  ...overrides
};